<template>
    <div class="login-body" v-if="!serviceStop">
        <div class="p-datatable-loading-overlay p-component-overlay" v-if="loading">
            <img src="@/assets/img/spiner-loader.png" alt="loading" />
        </div>
        <Toast />
        <div class="login-wrapper">
            <div class="login-panel">
                <form @submit.prevent="userLogin" class="login-form">
                    <img class="p-mb-4 login-logo" src="@/assets/img/new-logo.svg" alt="diamond-layout" />

                    <div class="p-d-flex p-ai-center p-col-12 p-pl-0 p-pt-0">
                        <h3 class="login_title p-mt-0">Вход в систему!</h3>
                    </div>

                    <div :class="inputGroupClasses" class="p-mt-1">
                        <InputText autocomplete="true" name="login" v-model="v$.ulogin.$model" placeholder="Логин" :class="v$.ulogin.$invalid && submitted ? 'p-error' : ''" />
                        <small v-show="submitted" v-for="error in showErrors(v$.ulogin)" :key="error.$uid" class="p-error">{{ error.$message }}</small>
                    </div>
                    <div :class="{ 'p-error': v$.password.$invalid && submitted }" class="p-field p-fluid p-d-flex p-flex-column p-ai-start p-col-12 p-pblank-0">
                        <Password autocomplete="off" :feedback="false" name="password" placeholder="Пароль" v-model="v$.password.$model" />
                        <small v-show="submitted" v-for="error in showErrors(v$.password)" :key="error.$uid" class="p-error">{{ error.$message }}</small>
                        <small class="p-error" v-html="authorizationFailed" />
                    </div>
                    <div class="p-mb-0 p-d-flex p-ai-end">
                        <Button label="Вход" type="submit" class="p-button p-component p-px-6"></Button>
                    </div>

                    <router-link to="/passRecovery" class="anc-decorate p-mt-3"> Забыли пароль? </router-link>
                    <router-link to="/registrationUser" class="anc-decorate p-mt-1"> Регистрация пользователя </router-link>
                    <router-link to="/registrationOrganization" class="anc-decorate p-mt-1"> Регистрация организации </router-link>
                </form>
                <div class="login-panel__faq">
                    <div class="p-d-flex p-ai-center p-col-12 p-pl-0 p-pt-0">
                        <h3 class="login_title p-mt-0">Часто задаваемые вопросы</h3>
                    </div>
                    <Accordion class="p-col-12 p-px-0 p-pt-0">
                        <AccordionTab v-for="question in FAQ" :key="question.id">
                            <template #header>
                                <div class="p-col-12 p-d-flex p-ai-center p-jc-between p-py-0 p-pl-0">
                                    <span class="p-ml-2 p-text-normal customLength">{{ question.name }} </span>
                                </div>
                            </template>
                            <p class="p-text-normal" v-html="question.description"></p>
                            <p v-if="question.files && question.files.length > 0" class="p-d-flex p-flex-column p-jc-center fileItemContainer">
                                <span v-for="questionFile in question.files" :key="questionFile.id" class="fileItem" @click="downloadFile(questionFile.name, questionFile.downloadUri)">
                                    <span class="pi pi-file"></span>
                                    {{ questionFile.name }}
                                </span>
                            </p>
                        </AccordionTab>
                    </Accordion>
                </div>
            </div>
            <LoginImage />
        </div>
    </div>
    <div class="login-body" v-else>
        <div class="p-datatable-loading-overlay p-component-overlay" v-if="loading">
            <img src="@/assets/img/spiner-loader.png" alt="loading" />
        </div>
        <Toast />
        <div class="login-wrapper">
            <div class="login-panel">
                <img class="p-mb-6 login-logo" src="@/assets/img/new-logo.svg" alt="diamond-layout" />

                <h3>Доступ запрещен</h3>
                Ведутся технические работы до 23.07.2024 00:00
            </div>
            <LoginImage />
        </div>
    </div>
</template>

<script>
import LoginImage from '@/components/loginComponents/LoginImage';
import { mapActions } from 'vuex';
import { downloadURI } from '@/main/utils/common';
import { required, minLength, helpers } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';

export default {
    name: 'login',
    components: {
        LoginImage,
    },
    setup: () => ({ v$: useVuelidate() }),
    data: () => ({
        loading: false,
        serviceStop: false,
        sidebar: false,
        authFall: false,
        ulogin: '',
        password: '',
        accessData: null,
        accessTokenInfo: null,
        submitted: false,
        authorizationFailed: '',
        inputGroupClasses: ['p-field', 'p-fluid', 'p-d-flex', 'p-flex-column', 'p-ai-start', 'p-col-12', 'p-pblank-0'],
        FAQ: [
            {
                id: 1,
                name: 'Добавление нового пользователя в организацию',
                description:
                    '<span>1. Сотруднику необходимо пройти регистрацию по адресу: <a class="green-link" href="https://ias.niioz.ru/registrationUser">https://ias.niioz.ru/registrationUser</a></span><br /><br />' +
                    '<span>2. Заполнить письмо по образцу («Активация нового сотрудника.docx»). Письмо необходимо заверить печатью организации, подписью руководителя или главного врача.</span><br /><br />' +
                    '<span>3. Для организаций контура ДЗМ письмо необходимо отправить по ЭДО. Для всех остальных организаций письмо нужно направить на почту <a class="green-link" href="mailto:helpcms@zdrav.mos.ru">helpcms@zdrav.mos.ru</a>. После того как служба технической поддержки получит письмо, аккаунт будет активирован в течение трёх рабочих дней. Подтверждение будет направлено на электронный адрес, указанный при регистрации.</span>',
                files: [
                    {
                        id: 101,
                        name: 'Активация нового сотрудника.docx',
                        downloadUri: '/assets/faq/activation-user.docx',
                    },
                ],
            },
            {
                id: 2,
                name: 'Регистрация новой организации в ИАС',
                description:
                    '<span>1. Необходимо зарегистрировать организацию в разделе «Регистрация организации»: <a class="green-link" href="https://ias.niioz.ru/registrationOrganization">https://ias.niioz.ru/registrationOrganization</a></span><br /><br />' +
                    '<span>2. Зарегистрировать пользователя в разделе «Регистрация пользователя»: <a class="green-link" href="https://ias.niioz.ru/registrationUser">https://ias.niioz.ru/registrationUser</a></span><br /><br />' +
                    '<span>3. Для организаций контура ДЗМ письмо необходимо отправить по ЭДО. Для всех остальных организаций письмо нужно направить на почту <a class="green-link" href="mailto:helpcms@zdrav.mos.ru">helpcms@zdrav.mos.ru</a>. После того как служба технической поддержки получит письмо, организация и пользователи будут активированы в течение трёх рабочих дней. Подтверждение будет направлено на электронный адрес, указанный при регистрации.</span>',
                files: [
                    {
                        id: 102,
                        name: 'Активация новой организации.docx',
                        downloadUri: '/assets/faq/activation-org.docx',
                    },
                ],
            },
            {
                id: 3,
                name: 'Блокирование учетной записи',
                description:
                    '<span>1. Заполнить письмо по образцу («Блокирование учетной записи.docx»).</span><br /><br />' +
                    '<span>2. Для организаций контура ДЗМ письмо необходимо отправить по ЭДО. Для всех остальных организаций письмо нужно направить на почту <a class="green-link" href="mailto:helpcms@zdrav.mos.ru">helpcms@zdrav.mos.ru</a>.</span><br /><br />' +
                    '<span>3. После получения письма служба технической поддержки заблокирует пользователя в течение трёх рабочих дней. Вход в Информационно-аналитическую систему общественного здоровья под заблокированной учетной записью невозможен.</span>',
                files: [
                    {
                        id: 103,
                        name: 'Блокирование учетной записи.docx',
                        downloadUri: '/assets/faq/blocking-account.docx',
                    },
                ],
            },
        ],
    }),

    validations() {
        const notHaveToMatch = () => this.ulogin !== this.password;
        return {
            ulogin: {
                required: { ...required, $message: 'Поле не должно быть пустым' },
                minLength: { ...minLength(2), $message: 'Длина не менее 2 цифр' },
            },
            password: {
                required: { ...required, $message: 'Поле не должно быть пустым' },
                minLength: { ...minLength(6), $message: 'Длина не менее 6 цифр' },
                notHaveToMatch: helpers.withMessage('Неверный логин или пароль. Повторите попытку', notHaveToMatch),
            },
        };
    },

    methods: {
        ...mapActions('auth', ['login']),

        async userLogin() {
            this.submitted = true;
            this.loading = true;
            if (!this.v$.$invalid) {
                try {
                    const result = await this.login({ login: this.ulogin, password: this.password });
                    if (result.message) {
                        this.authorizationFailed = result.message;
                        return;
                    }
                    await this.$router.push('/').catch(() => {});
                } catch (error) {
                    this.authorizationFailed = error.message;
                }
            }
            this.loading = false;
        },
        showErrors(data) {
            return data.$errors.length ? data.$errors : data.$silentErrors;
        },
        downloadFile(fileName, fileUri) {
            const ext = fileUri?.split('.').pop();

            downloadURI(fileName, ext, fileUri);
        },
    },
    computed: {
        isAuth() {
            return this.$store.state.auth.isAuth;
        },
        // authorizationFailed() {
        //     if (this.authFall) return 'Не правильное имя пользователя или пароль';
        //     return '';
        // },
    },
    watch: {
        login: function (newVal, oldVal) {
            newVal != oldVal ? (this.authorizationFailed = '') : null;
        },
        password: function (newVal, oldVal) {
            newVal != oldVal ? (this.authorizationFailed = '') : null;
        },
    },
    async created() {
        if ('true' === process.env.VUE_APP_SERVICE_STOP) {
            this.serviceStop = true;
        }
    },
};
</script>

<style lang="scss" scoped>
.login_title {
    font-size: 18px;
    text-align: left;
    font-style: normal;
    font-weight: normal;
    line-height: 21px;
    color: #4a4a4a;
    margin-bottom: 0;
}

.login-form {
    min-width: 270px !important;
}

.login-logo {
    height: 122px;
    width: 104px;
}

.anc-decorate {
    font-weight: normal;
    font-size: 12px;
    line-height: 21px;
    text-decoration-line: underline;
    color: #656565;
}

.p-component-overlay {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}

.p-fluid {
    padding: 0 !important;
}

.p-error .p-inputtext.p-component {
    border-color: #f44336 !important;
}

::v-deep .login-panel small {
    text-align: left;
}
.login-panel {
    &__faq {
        margin: 40px 20px 0;
        text-align: left;
        .green-link {
            text-decoration: underline;
            color: #388e3c;
        }
    }
}
.fileItem {
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 16px;
    color: #388e3c;
    margin-bottom: 8px;
    cursor: pointer;
}
.fileItemContainer {
    .fileItem:first-child {
        margin-top: 8px;
    }
    .fileItem:last-child {
        margin-bottom: 0;
    }
}
</style>

<style lang="scss">
.green-link {
    text-decoration: underline;
    color: #388e3c !important;
}
</style>
